import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { gaPackageBrowselinkedSection, gaPackageBrowseShopOrCustomizeClick } from "../../../util/googleAnalytics";
import { LinkedProducts } from '../../col-grad-annc/linkedProductModal';
import ProductOverView from "../productOverView";
import { GradPackageCard } from './gradPackageCard'

const GradPackageOverviw = ({ 
	packageList, 
	productList, 
	hsPaymentPromo, 
	fromGradPackages,
	altImage,
	pageContentData,
	googleAnalytics,
}) => {
	const [activePkgIdx, setActivePkgIdx] = useState(0);
	const [seeDatails, setSeeDetails] = useState(false);
	const [showCustomize, setShowCustomize] = useState(false);
	const [selectedProduct, setSelectedProduct] = useState();

	const onPkgCardClick = (pkgIdx) => {
		setActivePkgIdx(pkgIdx);
	};
	const showOwerviewPopup = async (e) => {
		e.preventDefault();
		setSeeDetails(true);		
	};
	const handleClosePopup = () => {
		setSeeDetails(false);
	};

	const logGASelectItemEvent = async (product, ctaName) => {
		try {
			googleAnalytics?.selectItemTrackingGASY25(
				googleAnalytics?.catalogOSR,
				googleAnalytics?.customerClassCode,
				ctaName || 'Customize', 
				'',
				product?.displayName,
				'button_click',
				pageContentData?.title || 'GradPackage Overview'
			);
			if (window?.jostensGaTracking?.gaEventsSpecPromise) {
				await Promise.all([window.jostensGaTracking.gaEventsSpecPromise])
			}
		} catch (err) {
			console.warn('GA tracking event failed', err)
		}
	}

	const onCustomizeClick = async (product, ctaName) => {
		await logGASelectItemEvent(product, ctaName)
		if(product?.linkedProducts?.length > 1 && !fromGradPackages) {
			gaPackageBrowselinkedSection(product)
			setShowCustomize(true)
			setSelectedProduct(product);
		} else if(product?.linkedProducts?.length === 1 && !fromGradPackages) {
			gaPackageBrowseShopOrCustomizeClick(product, ctaName)
			gaPackageBrowselinkedSection(product?.linkedProducts[0].publishedCatalogProductId)
			window.location.href = product?.linkedProducts[0].actionUrl;
		} else {
			!fromGradPackages && gaPackageBrowseShopOrCustomizeClick(product, ctaName)
			window.location.href = product.actionUrl;
		}
	};

	const packageItems = packageList
		.filter((product) => {
			return (
				product?.packageProductAvailability?.filter(
					(record) => record?.packageOsr === productList[activePkgIdx][fromGradPackages?'publishedCatalogProductId':'productOsr']
				).length > 0
			);
		})
		.map((product) => {
			return {
				...product,
				displayQtyByPackageOsr: product?.packageProductAvailability?.reduce(
					(acc, record) => {
						return {
							...acc,
							[record?.packageOsr]: parseInt(record?.display, 10),
						};
					},
					{}
				),
			};
		});

	return (
		<>
			<section className='grad-packages-overview-container p-3'>
				<div className='grad-package-card-list'>
					{productList?.length > 0 &&
						productList.map((pkgProduct, index) => (
							<GradPackageCard 
								key={pkgProduct[fromGradPackages ? 'publishedCatalogProductId' : 'productOsr']}
								activePkgIdx={activePkgIdx}
								fromGradPackages={fromGradPackages}
								index={index}
								onCustomizeClick={onCustomizeClick}
								onPkgCardClick={onPkgCardClick}
								pkgProduct={pkgProduct}
								showOwerviewPopup={showOwerviewPopup}
								googleAnalytics={googleAnalytics}
							/>
						))}
				</div>
				<div className='grad-package-overview'>
					{productList?.length > 0 && (
						<>
							<ProductOverView
								packageItems={packageItems}
								productDetails={productList[activePkgIdx]}
								hsPaymentPromo={hsPaymentPromo}
								activePkgIdx={activePkgIdx}
								onCustomizeClick={onCustomizeClick}
								altImage={altImage}
								fromGradPackages={fromGradPackages}
								googleAnalytics={googleAnalytics}
							/>
						</>
					)}
				</div>
				{seeDatails && productList?.length > 0 && (
					<Modal
						dialogClassName='pkg-see-details-modal'
						show={seeDatails}
						onHide={handleClosePopup}
						size='lg'>
						<Modal.Header closeButton></Modal.Header>
						<Modal.Body>
							<ProductOverView
								packageItems={packageItems}
								productDetails={productList[activePkgIdx]}
								hsPaymentPromo={hsPaymentPromo}
								activePkgIdx={activePkgIdx}
								onCustomizeClick={onCustomizeClick}
								altImage={altImage}
								fromGradPackages={fromGradPackages}
								googleAnalytics={googleAnalytics}
							/>
						</Modal.Body>
					</Modal>
				)}
			</section>
			{showCustomize && (
				<LinkedProducts
					linkedProducts={selectedProduct?.linkedProducts}
					showCustomize={showCustomize}
					setShowCustomize={setShowCustomize}
					altImage={altImage}
					product={selectedProduct}
					fromGradPackages={fromGradPackages}
					googleAnalytics={googleAnalytics}
				/>
			)}
		</>
	);
};

export default GradPackageOverviw;